import { BytesLike, ethers } from "ethers";
import useProvider from "../hooks/useProvider";
import CONTRACT_INFO from "../ContractInfo";
import { GMsV3 } from "../typechain-types";
import useClaimsAvailable from "../hooks/useClaimsAvailable";
import "./ClaimAllButton.scss";

const ClaimAllButton = () => {
  const provider = useProvider();
  const contract = provider
    ? (new ethers.Contract(
        CONTRACT_INFO[window.chain].contract,
        CONTRACT_INFO[window.chain].abi,
        provider.getSigner()
      ) as GMsV3)
    : undefined;
  const { numOfClaimsAvailable, claimProofs } = useClaimsAvailable();

  const claimAll = async () => {
    if (numOfClaimsAvailable > 0) {
      await contract?.claimAll(claimProofs as unknown as BytesLike[][]);
    }
  };

  if (!provider) {
    return (
      <div className="warning-text">
        Please connect your wallet to claim GMs.
      </div>
    );
  }

  return (
    <div className="claim-card">
      {Number(window.ethereum.networkVersion) ===
      CONTRACT_INFO[window.chain].chainId ? (
        <>
          <button
            className="button is-primary mb-2 claim-all-button"
            id="claimAllButton"
            onClick={claimAll}
            disabled={numOfClaimsAvailable <= 0}
          >
            Claim All
          </button>
          <div className="claim-text">
            You have {numOfClaimsAvailable} GM(s) to claim. Please reload screen
            after claiming.
          </div>
        </>
      ) : (
        <div className="claim-text">
          Please change network to Polygon to claim your GMs!
        </div>
      )}
    </div>
  );
};

export default ClaimAllButton;
